import { render, staticRenderFns } from "./project-monthly-add-or-update.vue?vue&type=template&id=6386c8c6&scoped=true&"
import script from "./project-monthly-add-or-update.vue?vue&type=script&lang=js&"
export * from "./project-monthly-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./project-monthly-add-or-update.vue?vue&type=style&index=0&id=6386c8c6&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386c8c6",
  null
  
)

export default component.exports